<style scoped>
.el-tab-sty {
  padding-left: 15px;
  border-radius: 6px 6px 0 0;
}
.el-col-6 {
  width: 30%;
  /* margin-bottom: 20px; */
}
.ipt-sty {
  width: 74% !important;
}
</style>
<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="back-color-fff el-tab-sty">
      <!-- @tab-click="handleClick" -->
      <el-tab-pane label="待审批" name="first">
        <div class="search-area" style="border-radius: 0 0 6px 6px; padding: 16px 16px 16px 0">
          <el-row :gutter="24">
            <el-col :span="8"
              ><div class="search-area-div w80">人员：</div>
              <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入人员"></el-input
            ></el-col>
            <el-col :span="8"
              ><div class="search-area-div w80">来源：</div>
              <el-select v-model="page.inviterTenantGuid" placeholder="请选择" class="ipt-sty">
                <el-option v-for="item in insuredCompanys" :key="item.guid" :label="item.tenantName" :value="item.guid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8"
              ><div class="search-area-div w80">到达时间：</div>
              <el-date-picker
                v-model="timeListS"
                type="daterange"
                range-separator="至"
                class="ipt-sty"
                :picker-options="pickerOptions"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <!-- <el-date-picker
                            v-model="page.arriveEndTime"
                            type="date"
                            class=" w75f"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                          </el-date-picker> -->
            </el-col>
          </el-row>
          <el-row :gutter="24" class="mt15 t-right">
            <el-col :span="24">
              <div>
                <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
                <el-button size="medium" type="danger" @click="empty">清空</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="button-area" style="padding-left: 0; padding-top: 0; margin-top: 0">
          <el-button size="medium" type="info" @click="add(1, '')">批量审批</el-button>
          <!-- <el-button size="medium" type="danger" @click="getDeleteData(1,'')">批量删除</el-button> -->
          <!-- <el-button plain size="medium">历史数据</el-button> -->
        </div>
        <div class="back-color-fff" style="padding: 16px 16px 16px 0">
          <el-table
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%"
            v-loading="tableLoadingFirst"
          >
            <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                <!-- {{scope.$index+1}} -->
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="staffName" label="人员" header-align="center" align="center"></el-table-column>
            <el-table-column prop="mobileNo" label="手机" header-align="center" align="center"></el-table-column>
            <el-table-column prop="inviterCompany" label="来源" header-align="center" align="center"></el-table-column>
            <el-table-column prop="inviterName" label="邀请人" header-align="center" align="center"></el-table-column>
            <el-table-column
              prop="inviterOrganisationName"
              label="邀请人组织"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="inviterPositionNames[0]"
              label="岗位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column prop="lastApprovalState" label="到达时间" sortable header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.lastApprovalTime | getDate }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <a class="txt-color" @click="add(2, scope.row)">审批 | </a>
                <a class="txt-color" @click="toLink(scope.row.staffGuid, true)">详情</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 30, 50]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </el-tab-pane>

      <el-tab-pane label="已审批" name="second">
        <div class="search-area" style="border-radius: 0 0 6px 6px; padding: 16px 16px 16px 0">
          <el-row :gutter="24">
            <el-col :span="8"
              ><div class="search-area-div w80">人员：</div>
              <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入账号"></el-input
            ></el-col>
            <el-col :span="8"
              ><div class="search-area-div w80">来源：</div>
              <el-select v-model="page.inviterTenantGuid" placeholder="请选择" class="ipt-sty">
                <el-option v-for="item in insuredCompanys" :key="item.guid" :label="item.tenantName" :value="item.guid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <div class="search-area-div w80">审批结果：</div>
              <div class="radio-sty t-left ml15">
                <el-radio v-model="page.approvalState" label="Y">通过</el-radio>
                <el-radio v-model="page.approvalState" label="R">驳回</el-radio>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="mt15">
            <el-col :span="8"
              ><div class="search-area-div w80">申请时间：</div>
              <el-date-picker
                v-model="timeListS1"
                type="daterange"
                range-separator="至"
                class="ipt-sty"
                :picker-options="pickerOptions"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="8"
              ><div class="search-area-div w80">审批时间：</div>
              <el-date-picker
                v-model="timeListS"
                type="daterange"
                range-separator="至"
                class="ipt-sty"
                :picker-options="pickerOptions"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="8" class="t-left">
              <el-button size="medium" type="info" @click="getInvitWaitapprovalList(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="button-area" style="padding-left: 0;">
                <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1,'')">添加用户</el-button>
                <el-button size="medium" type="danger" @click="getDeleteData(1,'')">批量删除</el-button>
                <el-button plain size="medium">历史数据</el-button>
            </div> -->
        <div class="back-color-fff" style="padding: 16px 16px 16px 0">
          <el-table
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%"
            v-loading="tableLoadingSecond"
          >
            <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                <!-- {{scope.$index+1}} -->
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="staffName" label="人员" header-align="center" align="center"></el-table-column>
            <el-table-column prop="mobileNo" label="手机" header-align="center" align="center"></el-table-column>
            <el-table-column prop="inviterCompany" label="来源" header-align="center" align="center"></el-table-column>
            <el-table-column prop="inviterName" label="邀请人" header-align="center" align="center"></el-table-column>
            <el-table-column
              prop="inviterOrganisationName"
              label="邀请人组织"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="inviterPositionNames[0]"
              label="岗位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column prop="approvalStartTime" label="申请时间" sortable header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.approvalStartTime | getDate }}</template>
            </el-table-column>
            <el-table-column prop="lastApprovalTime" label="审批时间" sortable header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.lastApprovalTime | getDate }}</template>
            </el-table-column>
            <el-table-column
              prop="lastApprovalState"
              label="审批结果"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <a class="txt-color" @click="toLink(scope.row.staffGuid, scope.row.lastApprovalState)">详情</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 30, 50]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="140px" :label-position="right" class="demo-ruleForm">
        <div
          style="background-color: #f1f1f1; height: 40px; line-height: 40px; text-align: left; padding-left: 15px"
          v-if="sumSh"
        >
          已选择数量：{{ multipleSelection.length }}
        </div>
        <br />
        <el-form-item label="签约/参保公司:">
          <el-select v-model="ruleForm.insuredCompanyGuid" placeholder="请选择" class="w100f">
            <el-option v-for="item in insuredCompanys" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同性质:">
          <el-select v-model="ruleForm.contractNature" placeholder="请选择" class="w100f">
            <el-option v-for="item in contractNatures" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约时长:" class="t-left">
          <el-radio v-model="ruleForm.duration" label="12">1年</el-radio>
          <el-radio v-model="ruleForm.duration" label="24">2年</el-radio>
          <el-radio v-model="ruleForm.duration" label="36">3年</el-radio>
        </el-form-item>
        <el-form-item label="合同日期:">
          <el-date-picker
            class="w100f"
            v-model="timeList"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="代缴公司:">
          <el-select v-model="ruleForm.withheldCompanyGuid" placeholder="请选择" class="w100f">
            <el-option v-for="item in withheldCompanys" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代征公司:">
          <el-select v-model="ruleForm.levyCompanyGuid" placeholder="请选择" class="w100f">
            <el-option v-for="item in levyCompanys" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见:">
          <el-input v-model="approvalSuggest" class="w100f" placeholder="请输入审批意见"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()" v-loading.fullscreen.lock="fullscreenLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'first',
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      insuredCompanys: [],
      contractNatures: [
        {
          value: '1',
          label: '劳动合同',
        },
        {
          value: '2',
          label: '劳务合同',
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      inviterTenant: [],
      withheldCompanys: [],
      levyCompanys: [],
      ruleForm: {
        staffInfo: '',
        insuredCompanyGuid: '',
        insuredCompanyName: '',
        contractNature: '',
        startTime: '',
        duration: '12',
        endTime: '',
        withheldCompanyGuid: '',
        withheldCompanyName: '',
        levyCompanyGuid: '',
        levyCompanyName: '',
        memo: '',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        staffName: '',
        inviterTenantGuid: '',
        // approvalState:'',
        arriveStartTime: '',
        arriveEndTime: '',
        applyStartTime: '',
        applyEndTime: '',
      },
      tableData: [],
      // rules: {
      //       insuredCompanyGuid: [
      //         { required: true, message: '请输入参保公司', trigger: 'blur' },
      //         { min: 1, max: 30, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //       ],
      //       pwd: [
      //         { required: true, message: '请输入密码', trigger: 'blur' },
      //         { min: 1, max: 60, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //       ],
      //       name: [
      //         { required: true, message: '请输入姓名', trigger: 'blur' },
      //         { min: 1, max: 30, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //       ],
      //       phone: [
      //         { required: true, message: '请输入手机号', trigger: 'blur' },
      //         { min: 1, max: 11, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //       ],
      //     },
      multipleSelection: [],
      approvalSuggest: '',
      sumSh: false,
      arriveEndTime: '',
      itemsList: '',
      timeList: [],
      timeList1: [],
      timeList2: [],
      timeListS: [],
      timeListS1: [],
      tableLoadingFirst: false,
      tableLoadingSecond: false,
      fullscreenLoading: false,
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenantDataGet();
    this.getWithheldCompanys();
    this.getLevyCompanys();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/entryApproval/detail') {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  methods: {
    empty() {
      let self = this;
      self.timeList = [];
      self.timeListS = [];
      self.timeList1 = [];
      self.timeList2 = [];
      self.timeListS1 = [];
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        staffName: '',
        inviterTenantGuid: '',
        arriveStartTime: '',
        arriveEndTime: '',
        applyStartTime: '',
        applyEndTime: '',
      };
      if (this.activeName == 'first') {
        this.getData(true);
      } else {
        this.getInvitWaitapprovalList(true);
      }
    },
    handleClick(tab, event) {
      this.empty();
      if (this.activeName == 'first') {
        this.getData(true);
      } else {
        this.getInvitWaitapprovalList(true);
      }
    },
    getTenantDataGet() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{ pageIndex: 1, pageSize: -1 }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.insuredCompanys = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getWithheldCompanys() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { pageIndex: 1, pageSize: -1 }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.withheldCompanys = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getLevyCompanys() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { pageIndex: 1, pageSize: -1 }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.levyCompanys = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
        self.timeList1 = self.timeListS;
      }
      if (
        self.timeList1 &&
        Array.isArray(self.timeList1) &&
        self.timeList1.length > 0 &&
        self.timeList1[0] &&
        self.timeList1[1]
      ) {
        self.page.arriveStartTime = self.$moment(self.timeList1[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.arriveEndTime = self.$moment(self.timeList1[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.arriveStartTime = '';
        self.page.arriveEndTime = '';
      }
      self.tableLoadingFirst = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get-waitapproval-list`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoadingFirst = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getInvitWaitapprovalList(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
        self.timeList1 = self.timeListS;
        self.timeList2 = self.timeListS1;
      }
      if (
        self.timeList1 &&
        Array.isArray(self.timeList1) &&
        self.timeList1.length > 0 &&
        self.timeList1[0] &&
        self.timeList1[1]
      ) {
        self.page.arriveStartTime = self.$moment(self.timeList1[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.arriveEndTime = self.$moment(self.timeList1[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.arriveStartTime = '';
        self.page.arriveEndTime = '';
      }
      if (
        self.timeList2 &&
        Array.isArray(self.timeList2) &&
        self.timeList2.length > 0 &&
        self.timeList2[0] &&
        self.timeList2[1]
      ) {
        self.page.applyStartTime = self.$moment(self.timeList2[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.applyEndTime = self.$moment(self.timeList2[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.applyStartTime = '';
        self.page.applyEndTime = '';
      }
      self.tableLoadingSecond = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get-approved-list`, self.page).then((res) => {
        console.log(res);
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoadingSecond = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add(flg, row) {
      let self = this;
      self.ruleForm.staffInfo = '';
      self.timeList = [];
      if (flg == 1) {
        if (self.multipleSelection == null || self.multipleSelection == '') {
          self.$message.error('请选择数据！');
          return;
        }
        self.sumSh = true;
        self.textTitle = '通过-补充入职信息';
        self.ruleForm.insuredCompanyGuid = '';
        self.ruleForm.insuredCompanyName = '';
        self.ruleForm.contractNature = '';
        self.ruleForm.startTime = '';
        self.ruleForm.duration = '12';
        self.ruleForm.endTime = '';
        self.ruleForm.endTime = '';
        self.ruleForm.withheldCompanyGuid = '';
        self.ruleForm.withheldCompanyName = '';
        self.ruleForm.levyCompanyGuid = '';
        self.ruleForm.levyCompanyName = '';
        self.ruleForm.memo = '';
        // self.ruleForm.userInfo = JSON.stringify(self.multipleSelection);
        self.ruleForm.staffInfo = JSON.parse('{' + self.itemsList.substring(0, self.itemsList.length - 1) + '}');
      } else {
        self.sumSh = false;
        self.textTitle = '通过-补充入职信息';
        self.ruleForm.insuredCompanyGuid = '';
        self.ruleForm.insuredCompanyName = '';
        self.ruleForm.contractNature = '';
        self.ruleForm.startTime = '';
        self.ruleForm.duration = '12';
        self.ruleForm.endTime = '';
        self.ruleForm.withheldCompanyGuid = '';
        self.ruleForm.withheldCompanyName = '';
        self.ruleForm.levyCompanyGuid = '';
        self.ruleForm.levyCompanyName = '';
        self.ruleForm.memo = '';
        self.itemsList = '';
        let items = '"' + row.staffGuid + '":"' + row.staffName + '",';
        console.log(items);
        if (self.itemsList == '') {
          self.itemsList = items; //JSON.stringify(items).replace("{","").replace("}","");
        } else {
          self.itemsList = self.itemsList + items; //+','+ JSON.stringify(items).replace("{","").replace("}","");
        }
        self.ruleForm.staffInfo = JSON.parse('{' + self.itemsList.substring(0, self.itemsList.length - 1) + '}');
      }
      this.dialogFormVisible = true;
    },
    submitForm() {
      let self = this;
      //   if(self.approvalSuggest == null || self.approvalSuggest == ''){
      //   self.$message.error("请输入审批意见！");
      //   return
      // }
      if (self.ruleForm.insuredCompanyGuid == null || self.ruleForm.insuredCompanyGuid == '') {
        // self.$message.error("请选择签约/参保公司！");
        // return
      } else {
        self.insuredCompanys.forEach(function (i) {
          if (self.ruleForm.insuredCompanyGuid == i.guid) {
            self.ruleForm.insuredCompanyName = i.tenantName;
          }
        });
      }
      if (self.ruleForm.contractNature == null || self.ruleForm.contractNature == '') {
        // self.$message.error("请选择合同性质！");
        // return
      }
      if (self.timeList == null || self.timeList == '') {
        // self.$message.error("请选择合同起始日期！");
        // return
      }
      if (
        self.timeList &&
        Array.isArray(self.timeList) &&
        self.timeList.length > 0 &&
        self.timeList[0] &&
        self.timeList[1]
      ) {
        self.ruleForm.startTime = self.$moment(self.timeList[0]).format('YYYY-MM-DD HH:mm:ss');
        self.ruleForm.endTime = self.$moment(self.timeList[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.ruleForm.startTime = '';
        self.ruleForm.endTime = '';
      }
      if (self.ruleForm.withheldCompanyGuid == null || self.ruleForm.withheldCompanyGuid == '') {
        // self.$message.error("请选择代缴公司！");
        // return
      } else {
        self.withheldCompanys.forEach(function (j) {
          if (self.ruleForm.withheldCompanyGuid == j.guid) {
            self.ruleForm.withheldCompanyName = j.tenantName;
          }
        });
      }
      if (self.ruleForm.levyCompanyGuid == null || self.ruleForm.levyCompanyGuid == '') {
        // self.$message.error("请选择代征公司！");
        // return
      } else {
        self.levyCompanys.forEach(function (i) {
          if (self.ruleForm.levyCompanyGuid == i.guid) {
            self.ruleForm.levyCompanyName = i.tenantName;
          }
        });
      }
      self
        .$confirm('信息未填写完整，确定提交吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          right: true,
        })
        .then(() => {
          let promise = {
            tenantGuid: self.$store.state.guid,
            approvalSuggest: self.approvalSuggest,
            laborContract: self.ruleForm,
          };
          console.log(promise);
          self.fullscreenLoading = true;
          // return
          self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/finish-approval`, promise).then((res) => {
            console.log('123', res.data);
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('审批成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审批',
          });
        });
    },
    toLink(guid, sh) {
      this.$router.push({ path: '/entryApproval/detail', query: {productGuid:this.$route.query.productGuid, guid: guid, sh: sh } });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      self.itemsList = '';
      val.forEach(function (item) {
        let items = '"' + item.staffGuid + '":"' + item.staffName + '",';
        console.log(items);
        if (self.itemsList == '') {
          self.itemsList = items; //JSON.stringify(items).replace("{","").replace("}","");
        } else {
          self.itemsList = self.itemsList + items; //+','+ JSON.stringify(items).replace("{","").replace("}","");
        }

        // items = items + items
        // console.log(JSON.stringify(self.multipleSelection));
        // .replace("[","").replace("]","").replace("{","").replace("}","")
        //item 就是当日按循环到的对象
        self.multipleSelection.push(items);
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      if (this.activeName == 'first') {
        this.getData();
      } else {
        this.getInvitWaitapprovalList();
      }
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      if (this.activeName == 'first') {
        this.getData();
      } else {
        this.getInvitWaitapprovalList();
      }
    },
  },
};
</script> 